
export default {
  name: "SwiperPagination",
  props: {
    title: {
      type: String,
    },
    content: {
      type: String,
    },
    slides: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 30,
        autoplay: {
          delay: 6000,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
    };
  },
};
